
import { Button, CloseButton, Drawer, Portal, Container, Flex, Menu, VStack, Avatar, Text } from "@chakra-ui/react"
import { memo, use, useState } from "react"
import { useApp } from "contexts/app";
import { useAuth } from "contexts/auth";
import { useNavigate } from "react-router";
import Profile from "pages/profile";
import { LuHouse } from "react-icons/lu";
import { useStore } from "contexts/store"

const DEFAULT_MENUS = [
    { title: "Trang chủ", url: "/" },
    { title: "Thư viện sản phẩm", url: "/gallery" },
    { title: "Bài viết", url: "/blog" },
]

const MenuLeft = () => {

    const navigate = useNavigate();
    const { showMenu, setShowMenu, showToast } = useApp();
    const { user, logout, showLogin } = useAuth();
    const { store } = useStore();
    const configuredMenus = Array.isArray(store?.web?.menus) && store.web.menus.length > 0
        ? store.web.menus
        : DEFAULT_MENUS

    const goTo = (path) => {
        navigate(path);
        setShowMenu(false);
    }

    const openMenuLink = (url) => {
        const nextURL = String(url || "").trim()
        if (!nextURL) {
            return
        }

        if (/^https?:\/\//i.test(nextURL)) {
            window.open(nextURL, "_blank", "noopener,noreferrer")
            setShowMenu(false)
            return
        }

        const internalPath = nextURL.startsWith("/") ? nextURL : `/${nextURL}`
        goTo(internalPath)
    }

    const loginApp = async () => {
        setShowMenu(false);
        var loggedInUser = await showLogin({});
        if (!loggedInUser) {
            return;
        }
        showToast({ description: "Đã đăng nhập", type: "success" })
    }
    return (
        <Drawer.Root open={showMenu} onOpenChange={(e) => setShowMenu(e.open)}>
            <Container maxW={"md"} maxHeight={"100vh"} overflow={"scroll"} style={{ padding: 0 }}>
                <Portal>
                    <Drawer.Backdrop />
                    <Drawer.Positioner>
                        <Drawer.Content>
                            <Drawer.Header>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div style={{ flexGrow: 1 }}>
                                        <Drawer.Title>
                                            <Drawer.Title>
                                                <Button variant={"ghost"} style={{ width: "100%", textAlign: "left" }} onClick={e => goTo("/")}>
                                                    <LuHouse></LuHouse> {store.web.title}
                                                </Button>
                                            </Drawer.Title>


                                        </Drawer.Title>
                                    </div>

                                    <Drawer.CloseTrigger asChild>
                                        <CloseButton size="lg" />
                                    </Drawer.CloseTrigger>
                                </div>

                            </Drawer.Header>
                            <Drawer.Body>
                                <VStack>


                                    {configuredMenus.map((item, index) => (
                                        <Button
                                            key={item?.id || `${item?.title || "menu"}_${index}`}
                                            variant={"ghost"}
                                            style={{ width: "100%", textAlign: "left" }}
                                            onClick={e => openMenuLink(item?.url)}
                                        >
                                            {item?.title || `Menu ${index + 1}`}
                                        </Button>
                                    ))}
                                    {user &&
                                        <Button variant={"ghost"} style={{ width: "100%", textAlign: "left" }} onClick={e => goTo("/profile")}>
                                            Tài Khoản
                                        </Button>
                                    }

                                    {/* <Button variant={"ghost"} style={{ width: "100%", textAlign: "left" }} onClick={e => goTo("/order-list")}>
                                        Đơn hàng
                                    </Button> */}
                                    {/* <Button variant={"ghost"} style={{ width: "100%", textAlign: "left" }} onClick={e => goTo("/policy")}>
                                        Chính sách
                                    </Button> */}

                                    {!user &&
                                        <Button variant={"ghost"} style={{ width: "100%", textAlign: "left" }} onClick={e => loginApp()}>
                                            Đăng nhập
                                        </Button>
                                    }

                                    {/* {user &&
                                        <Button variant={"ghost"} style={{ width: "100%", textAlign: "left" }} onClick={logout}>
                                            Đăng xuất
                                        </Button>
                                    }

 */}




                                </VStack>
                            </Drawer.Body>
                            {/* <Drawer.Footer>
                                <Drawer.CloseTrigger asChild>
                                    <Button variant="outline">Đóng</Button>
                                </Drawer.CloseTrigger>


                            </Drawer.Footer> */}


                        </Drawer.Content>

                    </Drawer.Positioner>
                </Portal>
            </Container>
        </Drawer.Root>
    )
}


export default memo(MenuLeft)